import Vue from 'vue'
import '@/styles'

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import TheMask from 'vue-the-mask'
Vue.use(TheMask)

import Money from 'v-money'
Vue.use(Money, { masked: false, decimal: ',', thousands: '.' })

import SlimDialog from 'v-slim-dialog'
Vue.use(SlimDialog)

import Toaster from 'v-toaster'
Vue.use(Toaster, { timeout: 5000 })

import Viewer from 'v-viewer'
Vue.use(Viewer)

import filters from './filters'
import moment from 'moment'
Vue.use(filters, { moment })

import Components from '@/components'
Vue.use(Components)

import Autocomplete from 'v-autocomplete'
import 'v-autocomplete/dist/v-autocomplete.css'
Vue.use(Autocomplete)

import TextEditor from './textEditor'
Vue.use(TextEditor)

import I18n from './i18n'
Vue.use(I18n)

import VueQuillEditor from 'vue-quill-editor'

import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
const options = {
  modules: {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      // ['blockquote', 'code-block'],
      [{ header: 1 }, { header: 2 }],
      // [{ list: 'ordered' }, { list: 'bullet' }],
      // [{ script: 'sub' }, { script: 'super' }],
      // [{ indent: '-1' }, { indent: '+1' }],
      // [{ direction: 'rtl' }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ align: [] }],
      ['clean'],
      ['link', 'image', 'video'],
    ],
  },
  placeholder: 'Adicione o texto',
  theme: 'snow',
}
Vue.use(VueQuillEditor, options)

import router from '@/router'
export default { router }
